/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Button } from "components/atoms/button/Button";
import { BreadcrumbArea } from "components/common/Link";
import { useI18n } from "hooks/i18n/i18n";
import { modalActions } from "modules/modal";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import type { Store } from "store";

export const PromptToLogin: React.FC = () => {
  const user = useSelector((state: Store) => state.auth.user);

  const { t } = useI18n();
  const design = styles();
  const dispatch = useDispatch();

  const watchLoginState = () => {
    if (!user.uid) {
      dispatch(modalActions.toggleLoginMethod());
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(watchLoginState, [user.uid]);

  return (
    <div id="contents" css={design.root}>
      <BreadcrumbArea
        // @ts-expect-error TS2322
        paths={[
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          ["/", "ホーム"],
          [null, t("common.routes.voucherCode")],
        ]}
      />

      <div css={design.main}>
        <div css={design.inner}>
          <div css={design.caution}>
            <div
              css={css`
                margin-bottom: 21px;
              `}
            >
              {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
              <p>バウチャーコードの入力にはログインが必要です。</p>
              {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
              <p>
                SPWN
                IDをお持ちの方は、下記のボタンよりログイン画面にお進みください。
              </p>
            </div>

            <div
              css={css`
                width: 360px;
                margin: 0 auto;
              `}
            >
              <Button
                // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
                text="ログイン"
                onClick={() => dispatch(modalActions.toggleLoginMethod())}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = () => {
  return {
    root: css`
      min-height: calc(100vh - 256px);
      margin: 0 auto;
      background-color: #ffffff;
    `,
    main: css`
      background-color: #ffffff;
    `,
    inner: css`
      max-width: 960px;
      width: 100%;
      margin: 0 auto;
      padding: 45px 20px;
      box-sizing: border-box;
    `,
    caution: css`
      text-align: center;
      p {
        font-size: 14px;
        font-weight: bold;
        line-height: 1.8em;
      }
    `,
  };
};
